import { requestCurrentInfo } from '@/api/person'

const user = {
  state: {
    token: '',
    userInfo: {},
    tutorialUrl: '',
    customerConfig: {
      customerImageUrl: "",
      groupImageUrl: "",
    },
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_TUTORIAL_URL: (state, url) => {
      state.tutorialUrl = url
    },
    SET_CUSTOMER_CONFIG: (state, config) => {
      state.customerConfig = config
    },
  },

  actions: {
    SetTutorialUrl({ commit }, url) {
      commit('SET_TUTORIAL_URL', url)
    },
    SetCustomerConfig({ commit }, config) {
      commit('SET_CUSTOMER_CONFIG', config)
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return requestCurrentInfo().then(response => {
        commit('SET_USER_INFO', response.data)
        return response
      })
    },

    // 登出
    LogOut({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
    }
  }
}

export default user
